/**
 * World keys: how this tab names a World it may reach with more than one key.
 *
 * Persona A's Worlds go by their names (`mill`); a persona's by `B:mill` or
 * `C:van`. A WorldName is lower case and has no colon, so a key never reads
 * as a name and the split is never ambiguous. Pure; imported by the Client,
 * the links, the stores and the reconciler.
 */

import type { Persona, WorldKey } from './contracts';

const KEY = /^([ABC]):([a-z0-9][a-z0-9._-]{0,62})$/;

/** Whose World this is and what the API calls it. */
export const worldRef = (key: WorldKey): { persona: Persona; w: string } => {
  const m = KEY.exec(key);
  return m ? { persona: m[1] as Persona, w: m[2]! } : { persona: 'A', w: key };
};

/** The key a persona's World goes by here: `mill`, or `B:mill`. */
export const worldKey = (persona: Persona, w: string): WorldKey => (persona === 'A' ? w : `${persona}:${w}`);

/** Whether a string is a persona's key (not a plain name). */
export const isPersonaKey = (key: string): boolean => KEY.test(key);
